import {useContext} from 'react';
import {WidthContext} from './WidthContext';

export const useWidthContext = () => useContext(WidthContext);
